<section class="ip-table" *ngIf="data">
  <div class="ip-table__top">
    <span class="ip-table__top--title" *ngIf="tableTitle">{{
      tableTitle | translate
    }}</span>
    <div class="ip-table__top--fn_inputs" *ngIf="!billed && optionalTitle">
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 1rem;
          align-items: center;
        " 
        *ngIf="mode === 'side'"
      >
        <app-back-navigate-button
          *ngIf="!consolidatedStep && !dateFiltersActive"
          [returnUrl]="'invopay/finance/consolidated'"
        ></app-back-navigate-button>
        <span class="ip-table__top--fn_inputs_title">{{
          optionalTitle | translate
        }}</span>
      </div>

      <!-- <div class="ip-table__top--fn_inputs__mobile-filters">
        <button (click)="openFiltersModal()">
          <span class="ip-table__top--fn_inputs__mobile-filters__span"
            >Filtrar</span
          >
          <img
            src="../../../../assets/icons/filters-icon.svg"
            alt=""
          />
        </button>
      </div> -->
      <div
        class="ip-table__top--fn_inputs__consolidated-info"
        *ngIf="consolidatedStep"
      >
        <div class="ip-table__top--fn_inputs__consolidated-info__val">
          <span class="ip-table__top--fn_inputs__consolidated-info__val-key">{{
            "IP.TABLE.PAY-INVOICES.TOTAL_SUPPLIERS" | translate
          }}</span>
          <span
            class="ip-table__top--fn_inputs__consolidated-info__val-value"
            >{{ totalsForConsolidated.totalSuppliers }}</span
          >
        </div>
        <div class="ip-table__top--fn_inputs__consolidated-info__val">
          <span class="ip-table__top--fn_inputs__consolidated-info__val-key">{{
            "IP.TABLE.PAY-INVOICES.TOTAL_INVOICES" | translate
          }}</span>
          <span
            class="ip-table__top--fn_inputs__consolidated-info__val-value"
            >{{ totalsForConsolidated.totalInvoices }}</span
          >
        </div>
        <div class="ip-table__top--fn_inputs__consolidated-info__val">
          <span class="ip-table__top--fn_inputs__consolidated-info__val-key">{{
            "IP.TABLE.PAY-INVOICES.TOTAL_PAY" | translate
          }}</span>
          <span class="ip-table__top--fn_inputs__consolidated-info__val-value"
            >${{ totalsForConsolidated.totalDue | amount }}</span
          >
        </div>
      </div>
      <ng-container *ngIf="mode === 'side'" [ngTemplateOutlet]="filters"></ng-container>
      <button 
        class="ip-table__btn"
        *ngIf="mode === 'over' && service !== 'consolidated-template'"
        (click)="openDialog()">
        <mat-icon class="ip-table__btn-icon">search</mat-icon> 
        <span>{{ "IP.FILTERS_MODAL.FILTER" | translate }}</span> 
      </button>
    </div>
  </div>

  <div class="ip-table__table" *ngIf="data.length">
    <app-table
      *ngIf="data.length && mode === 'side'"
      class="ip-table__table--desktop"
      [data]="data"
      [keyTranslate]="tableOption.keyTranslate"
      [actions]="tableOption.actions"
      tableStyle="invopay"
      (selectedItemsChange)="onInvoiceSelectionChange($event)"
      (sort)="onSortTable($event)"
      (action)="onActionTable($event)"
      [propertyOrder]="propertyOrder"
      [isForSelectItem]="isForSelectedItem"
      [scroll]="true"
    ></app-table>
    <app-card-table
      *ngIf="data.length && mode === 'over'"
      class="ip-table__table--mobile"
      [dataCard]="data"
      [service]="this.service"
      [actions]="tableOption.actions"
      [keyTranslate]="tableOption.keyTranslate"
      (selectedItemsChange)="onInvoiceSelectionChange($event)"
      (action)="onActionTable($event)"
      [isForSelectItem]="isForSelectedItem"
    >
    </app-card-table>
    <app-paginator
      *ngIf="data && totalItems > pageItems"
      [currentPages]="currentPage + 1"
      [itemsPerPage]="pageItems"
      [totalItems]="totalItems"
      (pageChange)="onPageChange($event)"
    ></app-paginator>
  </div>
  <div *ngIf="data">
    <app-no-data *ngIf="!data.length" [service]="service"></app-no-data>
  </div>
</section>

<ng-template #modalFilters *ngIf="mode === 'over'">
  <app-ip-modal-mobile [showCloseModal]="false" [title]="'IP.FILTERS_MODAL.FILTER' | translate">    
    <ng-container [ngTemplateOutlet]="filters"></ng-container>
  </app-ip-modal-mobile>
</ng-template>

<ng-template #filters>
  <div
        class="ip-table__top--fn_inputs-filters"
        *ngIf="!consolidatedStep && dateFiltersActive"
      >
        <form
          [formGroup]="datesForm"
          class="ip-table__top--fn_inputs-filters_dates-form"
        >
          <div class="ip-table__top--fn_inputs-filters_dates">
            <app-ip-date-input
            [control]="creationDate"
            inputId="createDateFrom"
            (changed)="onStartDateChange()"
            [max]="maxDate"
            [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.FROM' | translate"
            #startDateInput></app-ip-date-input>
          </div>
          <div class="ip-table__top--fn_inputs-filters_dates">
            <app-ip-date-input
            [control]="dueDate"
            inputId="createDateTo"
            (changed)="onFinishDateChange()"
            [min]="minEndDate"
            [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.TO' | translate"
            #dueDateInput></app-ip-date-input>
          </div>
        </form>
        <div class="ip-table__top--fn_inputs-filters_search">
          <app-ip-search-input
            #searchInput
            [hidePrefix]="true"
            [placeholder]="'Buscar'"
            *ngIf="
              this.service !== 'account-transactions' &&
              this.service !== 'card-transactions' &&
              searchField
            "
            (onSearch)="this.onSearch($event)"
          ></app-ip-search-input>
          <app-ip-button-modal
            typeBtn="action"
            (clicked)="this.executeService(searchValue)"
            [matTooltip]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.SEARCH' | translate"
            matTooltipPosition="above"
            [size]="'small'"
            [disabled]="!datesForm.valid"
            >
            <img
            class="ip-table__top--fn_inputs-filters-icon"
            src="assets/icons/search.svg"
          />
          </app-ip-button-modal>
        </div>
      </div>
</ng-template>